import { Link } from 'react-router-dom';
import { BookOpen, Newspaper, MonitorPlay, Printer, Home } from 'lucide-react';
import { DOCUMENTOS_GUIAS } from '../data/guiasDocumentos';
import '../styles/landing.css';

const stats = [
  { value: '168', label: 'reactivos totales', note: 'en una sola sesión' },
  { value: '138', label: 'forman el puntaje global', note: 'áreas transversales + módulo' },
  { value: '4.5 h', label: 'duración máxima', note: 'sin receso intermedio' },
  { value: 'A · B · C', label: 'opciones por reactivo', note: 'solo una correcta, sin penalización' },
];

const areas = [
  { name: 'Comprensión lectora', count: '30 reactivos' },
  { name: 'Redacción indirecta', count: '30 reactivos' },
  { name: 'Pensamiento matemático', count: '30 reactivos' },
  { name: 'Módulo disciplinar específico', count: '24–48 reactivos' },
  { name: 'Inglés como lengua extranjera', count: '30 (diagnóstico)' },
];

const AREA_ICONS = {
  'guia-sustentante': BookOpen,
  'folleto': Newspaper,
  'guia-desde-casa': Home,
  'modalidad-linea': MonitorPlay,
  'modalidad-impresa': Printer,
};

export default function ExamInfo() {
  return (
    <section id="exam-info" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <span className="exam-info-badge">Información oficial · CENEVAL</span>
          <h2>Conoce cómo es el examen EXANI-II</h2>
          <p className="section-subtitle">
            Datos extraídos de las guías oficiales del Centro Nacional de Evaluación para la
            Educación Superior: estructura, duración y modalidades de aplicación.
          </p>
        </div>

        <div className="exam-stats-grid">
          {stats.map((s) => (
            <div key={s.label} className="exam-stat">
              <span className="exam-stat-value">{s.value}</span>
              <span className="exam-stat-label">{s.label}</span>
              <span className="exam-stat-note">{s.note}</span>
            </div>
          ))}
        </div>

        <div className="exam-areas-panel">
          <div className="exam-areas-panel-header">
            <h3>Áreas del examen</h3>
            <span className="exam-areas-total">138 reactivos del puntaje global + 30 de diagnóstico</span>
          </div>
          <ul className="exam-areas-list">
            {areas.map((a) => (
              <li key={a.name}>
                <span className="exam-area-name">{a.name}</span>
                <span className="exam-area-count">{a.count}</span>
              </li>
            ))}
          </ul>
          <p className="exam-areas-note">
            El módulo disciplinar lo elige la institución educativa (p. ej. 24 reactivos por módulo).
            El inglés no se considera en el cálculo del puntaje global.
          </p>
        </div>

        <div className="exam-modalities">
          <span className="exam-modality">Aplicación impresa</span>
          <span className="exam-modality">Aplicación en línea (presencial)</span>
          <span className="exam-modality">Examen desde casa</span>
        </div>

        <div className="guias-cta">
          <h3>Estudia con el material oficial de CENEVAL</h3>
          <p>
            Las guías y el folleto oficial del EXANI-II están a tu disposición sin necesidad de
            registro. Ábrelas directo desde aquí o consulta todas en la sección de guías.
          </p>
          <Link to="/guias" className="guias-cta-btn">
            <span>Consulta las guías oficiales</span>
          </Link>
          <div className="guias-cta-sep">Acceso directo a cada guía</div>
          <div className="guias-cta-list">
            {DOCUMENTOS_GUIAS.map((doc) => {
              const Icon = AREA_ICONS[doc.id];
              return (
                <Link key={doc.id} to={`/guias?doc=${doc.id}`} className="guias-cta-card" aria-label={`Abrir ${doc.label}`}>
                  <span className="guias-cta-card-icon">{Icon ? <Icon size={18} /> : null}</span>
                  <span className="guias-cta-card-text">{doc.label}</span>
                  <span className="guias-cta-card-arrow">→</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}